module.exports = __webpack_public_path__ + "static/img/foto.415e17a4.jpg";